export default __webpack_public_path__ + "static/media/cwu9.9ddc95b2.jpeg";